import LegalLayout from "@/components/legal/LegalLayout";
import { LegalSection, LegalList } from "@/components/legal/LegalSection";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      lastUpdated="October 19, 2026"
      current="cookie-policy"
    >
      <p className="text-[16px] text-black/80 mb-10 leading-[1.8]">
        This Cookie Policy explains how Zynthoro uses cookies and similar
        technologies on zynthoro.ai. It should be read alongside our Privacy
        Policy.
      </p>

      <LegalSection id="what" number="1" title="What are cookies?">
        <p>
          Cookies are small text files stored on your device. We use them to
          keep you signed in, remember preferences and measure how the platform
          is used. Similar technologies include browser local storage.
        </p>
      </LegalSection>

      <LegalSection id="types" number="2" title="Cookies we use">
        <p>
          <strong>Strictly necessary (always on):</strong>
        </p>
        <LegalList
          items={[
            "access_token — HTTP-only sign-in cookie; the application sets a maximum age of 24 hours.",
            "zy_active_session — HTTP-only reference for the active workspace session; the application sets a maximum age of 12 hours.",
          ]}
        />
        <p className="mt-4">
          <strong>Preferences:</strong>
        </p>
        <LegalList
          items={[
            "zy_cookie_prefs_v1 — browser local storage recording your necessary, functional and analytics choices. It has no expiry timestamp in the preference record; you can change your choice in Cookie settings or remove it through browser controls.",
          ]}
        />
        <p className="mt-4">
          <strong>Analytics (only after consent):</strong>
        </p>
        <LegalList
          items={[
            "Google Analytics and Google Tag Manager — analytics scripts are loaded only after a saved analytics opt-in.",
            "PostHog — usage analytics and session replay on selected public pages, enabled through the analytics choice. Session replay is configured with masking and is restricted by the application's public-route controls.",
          ]}
        />
        <p>
          Analytics services can process identifiers, usage events and technical
          information. Session replay can collect information about interaction
          with a page. These activities should not be assumed to be anonymous.
          Our Google consent settings keep advertising consent denied.
        </p>
      </LegalSection>

      <LegalSection id="consent" number="3" title="Your choices">
        <p>
          On your first visit you'll see a cookie banner with three options:
          Accept all, Reject non-essential, or Customize. You can change your
          choice any time from the footer link <em>Cookie settings</em>.
          Analytics is optional. Withdrawing your choice changes the consent
          settings; it does not erase information already received by a provider.
        </p>
      </LegalSection>

      <LegalSection id="browser" number="4" title="Browser controls">
        <p>
          You can also clear or block cookies from your browser settings (see
          chrome.com, mozilla.org, support.apple.com). Disabling strictly
          necessary cookies will sign you out and prevent the platform from
          working.
        </p>
      </LegalSection>

      <LegalSection id="contact" number="5" title="Questions">
        <p>
          Reach Casa Haya International BV (KvK 99196581) at{" "}
          <a className="text-[var(--zy-blue)] font-semibold" href="mailto:info@zynthoro.ai">
            info@zynthoro.ai
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
